import { Route, Routes } from "react-router-dom";

import App from "./App";
import Home from "./view/Home";
import Login from "./Components/Login";

const Main = () => (
  <>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/content" element={<App />} />
      <Route path="/login" element={<Login />} />
      {/* <Route path="/not-found" element={<NotFound />} /> */}
      {/* <Navigate to="/not-found" /> */}
    </Routes>
  </>
);

export default Main;
